import { render } from "./TeilnehmerData.vue?vue&type=template&id=5b30a47f&scoped=true"
import script from "./TeilnehmerData.vue?vue&type=script&setup=true&lang=js"
export * from "./TeilnehmerData.vue?vue&type=script&setup=true&lang=js"

import "./TeilnehmerData.vue?vue&type=style&index=0&id=5b30a47f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b30a47f"],['__file',"resources/js/components/start/TeilnehmerData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b30a47f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b30a47f', __exports__)) {
    api.reload('5b30a47f', __exports__)
  }
  
  module.hot.accept("./TeilnehmerData.vue?vue&type=template&id=5b30a47f&scoped=true", () => {
    api.rerender('5b30a47f', render)
  })

}


export default __exports__